export function exportToExcel(headerData,filterVal,list,excelName) {
  //excel数据导出
  require.ensure([],() => {
    const {
      export_json_to_excel
    } = require('../export/Export2Excel')
    const tableData = list.map(v => filterVal.map(j => v[j]))
    export_json_to_excel(headerData, tableData, excelName)
  })
}
// 1.传入的headerData为字段对应的中文，如const headerData = ['库房', '库房说明', '库房类型', '存储环境',
//           '补货条码数', '索取任务数', '容器类型','是否设备分货位',
//           '是否入库复核','是否称重','是否序列化管理']
// 2.filterVal为字段名,如const filterVal = ['no', 'name', 'storageRoomType', 'storageEnvironment',
//           'numberOfBarcode', 'numberOfPickingOrder', 'containerType',
//           'allocable','checkable','weighable', 'serialNumberManagement']
//3.list为数据源，数据源中必须包含传入的字段名
//4.excelName为excel表的名字，如const excelName='库房资料'
// import格式为 import { exportToExcel } from '@/components/Excel/export/exportFunction'
// 如启动的时候报错需执行npm install -S file-saver xlsx和npm install -D script-loader